__turbopack_context__.v({
  "loading-state": "CalendarInsightsWidget-module__qb2Cqq__loading-state",
  "scrollableTabsWrapper": "CalendarInsightsWidget-module__qb2Cqq__scrollableTabsWrapper",
  "showScrollShadow": "CalendarInsightsWidget-module__qb2Cqq__showScrollShadow",
  "tableWrapper": "CalendarInsightsWidget-module__qb2Cqq__tableWrapper",
});
